import { fromJS } from 'immutable';

import {
  BOOTSTRAP_LOGIN_AUTOMATED
} from './constants';

const initialState = fromJS({
  apiData: null,
  apiDataLoading: null,
  apiDataLoaded: null,
  apiDataError: null,
  initialDataConfig: null
});

const loginAutomatedReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOTSTRAP_LOGIN_AUTOMATED:
      return state
        .set('initialDataConfig', action.data);
    default:
      return state;
  }
};

export default loginAutomatedReducer;



// WEBPACK FOOTER //
// ./src/containers/LoginAutomatedPage/reducer.js